import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';

const marketStates = {
  Sideways: '🤷',
  Bull: '🐂',
  Bear: '🐻',
};

export default function TopNav() {
  const [state, setState] = useState('');
  const [isFetched, setIsFetched] = useState(false);

/*   useEffect(() => {
    const fetchMarketState = async () => {
      try {
        const res = await axios.get("http://localhost:5000/marketstate", {
          headers: { "Content-Type": "application/json" }
        });
        setState(res.data);
        setIsFetched(true);
      } catch (error) {
        console.error("Error fetching market state:", error);
      }
    };

    if (!isFetched) {
      fetchMarketState();
    }
  }, [isFetched]); */

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography textAlign="center" variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Dollars
        </Typography>
        <Box id="marketState">
          {marketStates[state]}
        </Box>
      </Toolbar>
    </AppBar>
  );
}